













import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import SuiPopup from '@/components/Popup/index.vue'
import SuiIcon from '@/components/Icon/index.vue'

enum ICON_TYPE {
  error = 'ProgressError',
  success = 'ProgressTick',
  warn = 'Tips',
  loading = 'loading',
}
type IIconType = keyof typeof ICON_TYPE

/**
 * @component
 * @description 轻提示组件，主要场景用来一些轻度文案提示，提供自定义类型、自定显示内容、自定义图标、自定义显示时间等
 */
@Component({
  name: 'SuiToast',
  components: {
    SuiPopup,
    SuiIcon
  }
})
export default class Comp extends Vue {
  static install(vue: any) {
    vue.component((this as any).options.name, Comp)
  }

  /**
  * @prop icon
  * @type string
  * @description 图标
  * @options ['error', 'success', 'warn', 'loading']
  */
  @Prop({
    type: String,
    validator(val: IIconType) {
      return !!ICON_TYPE[val]
    }
  })
  icon!: IIconType

  /**
  * @prop v-model
  * @type boolean
  * @description 是否展示
  * @default false
  */
  @Prop({
    type: Boolean,
  })
  value!: boolean

  /**
  * @prop loose
  * @type boolean
  * @description 间距宽松，适合有图标并且有长文字的情景
  * @default false
  */
  @Prop({
    type: Boolean,
    default: false
  })
  loose!: boolean

  /**
  * @prop duration
  * @type number
  * @description 展示时间，如果传入-1, 则不自动关闭
  * @default 3000
  */
  @Prop({
    type: Number,
    default: 3000
  })
  duration!: number

  @Prop({
    type: String,
  })
  text!: string

  timeoutId!: number

  @Watch('value')
  valueChange() {
    if (this.value) {
      if (this.duration > 0) {
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
          this.$emit('input', false)
        }, this.duration)
      }
    }
  }

  get iconType() {
    return ICON_TYPE[this.icon]
  }
}
/**
* @slot default
* @description toast 内容
*/
/**
* @slot icon
* @description 图标
*/
